import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-20 bg-secondary-950 text-secondary-100">
      <div className="w-full px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          <div className="md:col-span-5">
            <div className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-accent-500 text-foreground-950">
                <i className="ri-goblet-fill text-lg"></i>
              </span>
              <span className="font-heading text-xl font-black text-background-50">
                黑料每日
              </span>
            </div>
            <p className="mt-4 max-w-sm text-sm leading-relaxed text-secondary-300">
              每日娱乐热点整理与归档平台。更新帖持续追踪当天动态，汇总清单按主题梳理脉络，历史归档方便随时回溯。信息以整理为主，涉及主体多用泛化表述。
            </p>
            <div className="mt-5 flex items-center gap-2.5">
              <a
                href="mailto:contact@heiliaodaily.example"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-secondary-800 text-secondary-100 transition-colors hover:bg-secondary-700"
                aria-label="邮件联系"
              >
                <i className="ri-mail-line"></i>
              </a>
              <a
                href="#contact"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-secondary-800 text-secondary-100 transition-colors hover:bg-secondary-700"
                aria-label="留言反馈"
              >
                <i className="ri-chat-3-line"></i>
              </a>
              <a
                href="#top"
                className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-md bg-secondary-800 text-secondary-100 transition-colors hover:bg-secondary-700"
                aria-label="返回顶部"
              >
                <i className="ri-arrow-up-line"></i>
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <h3 className="text-sm font-semibold text-background-50">内容方向</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/summary?cat=${cat.id}`}
                    className="cursor-pointer text-secondary-300 transition-colors hover:text-accent-300"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-sm font-semibold text-background-50">站点导航</h3>
            <ul className="mt-4 space-y-2.5 text-sm">
              <li>
                <Link to="/" className="cursor-pointer text-secondary-300 transition-colors hover:text-accent-300">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/summary" className="cursor-pointer text-secondary-300 transition-colors hover:text-accent-300">
                  汇总清单
                </Link>
              </li>
              <li>
                <Link to="/archive" className="cursor-pointer text-secondary-300 transition-colors hover:text-accent-300">
                  归档中心
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-secondary-300 transition-colors hover:text-accent-300">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div className="md:col-span-2">
            <h3 className="text-sm font-semibold text-background-50">联系</h3>
            <ul className="mt-4 space-y-2.5 text-sm text-secondary-300">
              <li>邮箱：contact@heiliaodaily.example</li>
              <li>更新：每日整理</li>
              <li>反馈：关于我们页留言</li>
            </ul>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-secondary-800 pt-6 text-xs text-secondary-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 黑料每日 · 娱乐热点整理与归档。内容仅供参考，请理性看待。</p>
          <p className="whitespace-nowrap">拒绝未经核实的信息，坚持标注待确认内容。</p>
        </div>
      </div>
    </footer>
  );
}